module.exports = __webpack_public_path__ + "static/media/menu-1.43900578.png";